﻿import type { AxiosRequestConfig } from 'axios';

/**
 * Base API client containing an option transform function to
 * make sure that header values are not empty strings - that can lead
 * to 404's when omitting parameters being sent as headers.
 */
export default class BaseClient {
    transformOptions(options: AxiosRequestConfig): Promise<AxiosRequestConfig> {
        Object.keys(options.headers || {}).forEach(header => {
            if (options.headers?.[header] === "") {
                options.headers[header] = undefined;
            }
        });

        return Promise.resolve(options);
    }
}